import React, { useRef, useEffect } from 'react';
import { ClickableElement, Flex, useMenuContext } from '@cko/primitives';
import { IconActionSearch, IconActionCross } from '@cko/icons';
import { debounce } from '@cko/utils';
import styled from 'styled-components';
const FlexContainer = styled(Flex) `
  height: 32px;
  border: var(--border-b-seed) solid var(--base-border-secondary);
  border-radius: ${({ isPanelOpen }) => isPanelOpen
    ? 'var(--border-r-sandgrain) var(--border-r-seed) var(--border-r-sandgrain) var(--border-r-sandgrain)'
    : 'var(--border-r-sandgrain) var(--border-r-seed) var(--border-r-seed) var(--border-r-sandgrain)'};
  width: ${({ inputWidth }) => inputWidth}px;
`;
const IconButton = styled(ClickableElement) `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  cursor: pointer;
`;
const SearchButton = styled(IconButton) `
  border-left: var(--border-b-seed) solid var(--base-border-secondary);
  border-radius: var(--border-r-sandgrain);
`;
const StyledInput = styled.input `
  padding: 5px;
  border: none;
  flex: 1;
  font: var(--body-xs);

  :focus {
    outline: none;
    border: none;
  }
`;
export const SearchInput = (props) => {
    const { submit, inputRef, onChange, isPanelOpen, value, onFocus, onClear, onInputWidthChange } = props;
    const { getInputProps } = useMenuContext();
    const inputContainerRef = useRef(null);
    const inputWidth = isPanelOpen ? '100%' : 360;
    useEffect(() => {
        const searchInputWith = inputContainerRef?.current?.getBoundingClientRect().width || 360;
        onInputWidthChange(searchInputWith);
        const handleResize = debounce(() => {
            onInputWidthChange(searchInputWith);
        }, 100);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [onInputWidthChange]);
    return (React.createElement("form", { ref: inputContainerRef, onSubmit: submit, "data-analytics-id": "search-form" },
        React.createElement(FlexContainer, { inputWidth: inputWidth, isPanelOpen: isPanelOpen },
            React.createElement(StyledInput, { type: "text", ref: inputRef, "data-testid": "search-input", "data-analytics-id": "search-input", onFocus: onFocus, ...getInputProps(), onChange: onChange, value: value, placeholder: "Search" }),
            value && (React.createElement(IconButton, { type: "button", onClick: onClear, "data-analytics-id": "search-clear-button", "data-testid": "clear-btn", "aria-label": "Clear search" },
                React.createElement(IconActionCross, null))),
            React.createElement(SearchButton, { type: "submit", "data-testid": "search-btn", "data-analytics-id": "search-button", "aria-label": "Submit search" },
                React.createElement(IconActionSearch, null)))));
};
